import type { FC } from "react";

import type { Finding } from "../model/Finding";
import { FindingContext } from "./FindingContext";
import type { FindingVariant } from "./FindingProps";
import { findingRenderers } from "./registry";

type FindingViewProps = {
  finding: Finding;
  variant?: FindingVariant;
};

// Находка любого кода через реестр; карточка полного вида дорисует советы из контекста. Сужение union по `code` не доходит до индекса
// в реестре, поэтому компонент берётся с общим типом: пару «код — params» гарантирует `Finding`.
export const FindingView = ({ finding, variant }: FindingViewProps) => {
  const Renderer = findingRenderers[finding.code] as FC<FindingViewProps>;
  return (
    <FindingContext value={finding}>
      <Renderer finding={finding} variant={variant} />
    </FindingContext>
  );
};
